document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.querySelector(".js-load-more");
  const productGrid = document.querySelector("[data-product-grid]");
  const totalCountEl = document.getElementById("total-count");
  const shownCountEl = document.getElementById("shown-count");
  const progressBar = document.getElementById("progress-bar");
  const progressWrapper = document.getElementById("progress-wrapper");
  const progressText = document.getElementById("progress-text");

  const totalCount = parseInt(totalCountEl?.textContent || "0", 10);

  if (!productGrid) return;

  function updateProgress() {
    const currentShown = productGrid.querySelectorAll(".product-card").length;

    // Update count in text
    if (shownCountEl) shownCountEl.textContent = currentShown;

    // Set bar width
    if (progressBar && totalCount) {
      const percent = Math.min((currentShown / totalCount) * 100, 100);
      progressBar.style.width = percent + "%";
      progressBar.style.display = "block";
    }

    // Update the text line
    if (progressWrapper && progressText && totalCountEl) {
      progressWrapper.style.display = "block";
      progressText.innerHTML = `Showing <span id="shown-count">${currentShown}</span> of <span id="total-count">${totalCount}</span> Items`;
    }
  }

  updateProgress(); // Run on initial page load

  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", function () {
    const nextUrl = loadMoreBtn.getAttribute("data-next-url");
    if (!nextUrl) return;

    loadMoreBtn.textContent = "Loading...";

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProductGrid = doc.querySelector("[data-product-grid]");
        const newProductCards = newProductGrid?.querySelectorAll(".product-card") || [];

        if (newProductCards.length === 0) {
          loadMoreBtn.remove();
          return;
        }

        newProductCards.forEach((card) => {
          productGrid.appendChild(card);
        });

        updateProgress(); // After new items added

        const nextBtn = doc.querySelector(".js-load-more");

        if (nextBtn && nextBtn.hasAttribute("data-next-url")) {
          loadMoreBtn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
          loadMoreBtn.textContent = "Load more →";
        } else {
          loadMoreBtn.style.opacity = "0";
          setTimeout(() => loadMoreBtn.remove(), 300);
        }
      })
      .catch((err) => {
        console.error("Load more failed:", err);
        loadMoreBtn.textContent = "Error. Try again.";
      });
  });
});
